const fundationPlugin = store => {
    // called when the store is initialized

    // store.subscribe((mutation, state) => {
    //     // called after every mutation.
    //     // The mutation comes in the format of `{ type, payload }`.
    // })
}

export default fundationPlugin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/plugins.js
// module id = null
// module chunks = 